import React, { useEffect, useRef } from 'react';
import { ManualAddressProps } from '../types';
import trackEvent from '../../../../../helpers/gtm/eventPush';

const ManualAddressForm: React.FC<ManualAddressProps> = (props) => {
  const {
    backButtonType,
    hideManualEntry,
    localisations,
    getStoredAddress,
    storedAddress,
    setStoredAddress,
    setStreetNameInput,
    trackingContext,
    inputClass,
  } = props;

  // State management
  const postcodeRef = useRef<HTMLInputElement>(null);
  const line2Ref = useRef<HTMLInputElement>(null);

  // Back to search button text
  const backButtonText =
    backButtonType === 'postcode'
      ? localisations.search_by_postcode
      : localisations.search_by_address;

  // Checking for a stored address
  useEffect(() => {
    const address = JSON.parse(getStoredAddress());
    const { postcode, line_2 } = address;
    if (postcodeRef.current) {
      postcodeRef.current.value = postcode ? postcode.toUpperCase() || '' : '';
    }
    if (line2Ref.current) {
      line2Ref.current.value = line_2 || '';
    }
    setStreetNameInput(line_2);
  }, [getStoredAddress, setStreetNameInput]);

  // Function to handle input change
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const postcode = postcodeRef.current ? postcodeRef.current.value : '';
    const line_2 = line2Ref.current ? line2Ref.current.value : '';
    const add = {
      manual: true,
      postcode,
      line_2,
    };
    setStoredAddress(add);
    setStreetNameInput(line_2);
  };

  // Function to handle input invalid
  const handleInputInvalid = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const { value, name } = event.target;
    trackEvent({
      category: 'Form error',
      action: `${trackingContext}_st_1:manual_${name}`,
      label: `Please fill in this field|field=${value}`,
    });
  };

  // Function to handle button click
  const handleButtonClick = (): void => {
    hideManualEntry({ track: true });
  };

  return (
    <>
      <div className="address_manual_form">
        <div className="autosuggest__manual-field">
          <label
            className="autosuggest__manual-label"
            htmlFor="manual_address-line_2"
          >
            {localisations.label_line_2}
          </label>
          <input
            ref={line2Ref}
            type="text"
            name="line_2"
            id="manual_address-line_2"
            size={35}
            placeholder={localisations.placeholder_street_name}
            required
            onChange={handleInputChange}
            onInvalid={handleInputInvalid}
            defaultValue={storedAddress.line_2}
            className={inputClass}
          />
        </div>
        <div className="autosuggest__manual-field">
          <label
            className="autosuggest__manual-label"
            htmlFor="manual_address-postcode"
          >
            {localisations.label_postcode}
          </label>
          <input
            ref={postcodeRef}
            type="text"
            name="postcode"
            id="manual_address-postcode"
            size={20}
            placeholder={localisations.placeholder_postcode}
            required
            onChange={handleInputChange}
            onInvalid={handleInputInvalid}
            defaultValue={storedAddress.postcode}
            className={inputClass}
          />
        </div>
      </div>
      <div className="address_manual_action">
        <button
          type="button"
          className="autosuggest__manual-button"
          onClick={handleButtonClick}
        >
          {backButtonText}
        </button>
        <input type="hidden" name="street_name" defaultValue="" />
      </div>
    </>
  );
};

export default ManualAddressForm;
